import { __rest } from "tslib";
import { map, omit } from 'lodash';
/** @deprecated legacy */
export function sanitizeContent(_a) {
    var { content } = _a, rest = __rest(_a, ["content"]);
    const blocks = map(content.blocks, removeRedundantTextAlignment);
    return Object.assign(Object.assign({}, rest), { content: Object.assign(Object.assign({}, content), { blocks }) });
}
/**
 Removes text alignment from atomic blocks, because when atomic block is in selection range it's possible to set it's data.textAlignment prop.
 Removes left text alignment from text blocks, because it's a default value.
 */
function removeRedundantTextAlignment(block) {
    return block.type === 'atomic'
        ? omitTextAlignment(block)
        : omitLeftTextAlignment(block);
}
function omitLeftTextAlignment(block) {
    var _a;
    return ((_a = block.data) === null || _a === void 0 ? void 0 : _a.textAlignment) === 'left'
        ? omitTextAlignment(block)
        : block;
}
function omitTextAlignment(block) {
    return omit(block, 'data.textAlignment');
}
//# sourceMappingURL=sanitize-content.js.map